import React from "react";

const ExchangeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
    >
      <path d="M14.5 11L10.5 15L14.5 19" stroke="#3A393A" strokeWidth="1.5" />
      <path
        d="M4.21478 13.3169C3.0825 12.3364 2.49815 11.0645 2.85172 9.72166C3.18922 8.43987 4.31111 7.39196 5.80063 6.6472C7.31056 5.89223 9.23683 5.42435 11.276 5.29012C13.3181 5.15569 15.4006 5.36056 17.208 5.88231C19.0001 6.39965 20.5011 7.22349 21.3925 8.29946C22.3213 9.42061 22.5281 10.7618 21.8544 12.0189C21.2206 13.2017 19.899 14.1367 18.2475 14.7703C16.5763 15.4115 14.5571 15.75 12.5 15.75"
        stroke="#3A393A"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default ExchangeIcon;
